import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { queryKeys } from "@/api/query-keys";
import { forkConversation, setActiveBranch } from "../api/conversationThread";

/** Switch the active branch of a conversation, then re-sync its thread. */
export function useSetActiveBranch(conversationId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (leafMessageId: string) => setActiveBranch(conversationId, leafMessageId),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: queryKeys.conversations.detail(conversationId) }),
  });
}

/** Fork a message into a fresh conversation and navigate to it. */
export function useForkConversation() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: ({ conversationId, messageId }: { conversationId: string; messageId: string }) =>
      forkConversation(conversationId, messageId),
    onSuccess: (conversation) => {
      void qc.invalidateQueries({ queryKey: queryKeys.conversations.all });
      void navigate({ to: "/chat/$id", params: { id: conversation.id } });
    },
  });
}
